module.exports = __webpack_public_path__ + "static/media/main-search-image.f8ba7057.png";